<template>
  <div></div>
</template>

<script>
export default {
  created() {
    console.log(this.$router.currentRoute.query);
  }
}
</script>

<style>

</style>
